import { faArrowRightFromBracket, faGlobe } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"
import i18n from "../../i18n"
import { useDispatch, useSelector } from "react-redux"
import { useLogoutApiMutation } from "../../pages/Login/Services/loginService"
import { useTranslation } from "react-i18next"
import { setLocationModal } from "../../pages/Common/commonSlice"

const MainHeaderComponent = () => {
    const regionalLanguages = [
        { id: "en", label: "English" },
        { id: "hn", label: "हिन्दी" },
        { id: "mr", label: "मराठी" }
    ]

    const { t: translate } = useTranslation()

    const [logoutApi] = useLogoutApiMutation()

    const token = useSelector((state: any) => state.auth.token)

    const dispatch = useDispatch()

    const [selectedLanguage, setSelectedLanguage] = useState<any>(localStorage.getItem("lang") !== null ? localStorage.getItem("lang") : "en")
    
    const [userToken, setUserToken] = useState(false)
    
    useEffect(() => {
        setUserToken(token ? true : false)
    }, [token])

    useEffect(() => {
        const lang = localStorage.getItem("lang") !== null ? localStorage.getItem("lang") : "en";
        setSelectedLanguage(lang)
    }, [localStorage])

    const handleChangeLanguage = (language: any) => {
        i18n.changeLanguage(language)
        localStorage.setItem("lang", language)
    }

    const handleSignOut = () => {
        logoutApi("").then((response: any) => {
            if (response?.data?.meta?.status_code === 200 || response?.data?.meta?.status_code === 403) {
                localStorage.clear()
                localStorage.setItem("lang", "en")
                // Back to the auth screen of the lane being used, not always commissioning.
                window.location.href = window.location.pathname.startsWith("/site-survey")
                    ? "/site-survey/auth"
                    : "/commissioning-form/auth"
                dispatch(setLocationModal({ locationModal: true }))
            }
        })
    }

    return <Box className="commissioning_report_header">
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="18" viewBox="0 0 100 18" fill="none">
            <path d="M27.3567 14.3057C25.7888 14.3057 25.0879 12.9213 25.0879 11.5475V4.05767H30.7721V0.273438H18.1172V4.05767H20.6534V11.1105C20.6534 13.4055 21.2634 15.1744 22.4677 16.37C23.541 17.4362 25.0704 17.999 26.8935 17.999C29.8509 17.999 31.861 16.2266 32.326 15.7757L30.4452 13.0612C30.0205 13.4177 28.8197 14.3057 27.3567 14.3057Z" fill="#242731" />
            <path d="M75.6164 0.273438H71.1016V17.7211H75.6164V0.273438Z" fill="#242731" />
            <path d="M63.802 14.3057C62.2341 14.3057 61.5332 12.9213 61.5332 11.5475V4.05767H67.2174V0.273438H61.5332H57.0987H54.5625V4.05767H57.0987V11.1105C57.0987 13.4055 57.7087 15.1744 58.9131 16.37C59.9863 17.4362 61.5157 17.999 63.3388 17.999C66.2962 17.999 68.3063 16.2266 68.7713 15.7757L66.8905 13.0612C66.4675 13.4177 65.265 14.3057 63.802 14.3057Z" fill="#242731" />
            <path d="M99.516 14.3574H95.529C96.6948 12.8594 97.3853 11.0066 97.3853 8.99826C97.3853 4.02894 93.1588 0 87.9465 0C82.7343 0 78.5078 4.02894 78.5078 8.99826C78.5078 13.819 82.4843 17.7536 87.4799 17.986V17.9965H87.9465C87.9465 17.9965 87.9465 17.9965 87.9483 17.9965C87.95 17.9965 87.9483 17.9965 87.95 17.9965H99.5195V14.3574H99.516ZM83.0699 8.99826C83.0699 6.20334 85.253 3.93805 87.9465 3.93805C90.6401 3.93805 92.8232 6.20334 92.8232 8.99826C92.8232 11.7932 90.6401 14.0585 87.9465 14.0585C85.253 14.0585 83.0699 11.7932 83.0699 8.99826Z" fill="#242731" />
            <path d="M47.3707 2.6411L47.2204 2.47155C45.6717 0.877455 43.6494 0 41.5292 0C36.7993 0 33.0938 3.95378 33.0938 9.00001C33.0938 14.1301 36.7207 18 41.5292 18C43.6511 18 45.6717 17.1226 47.2204 15.5285L47.3707 15.3642V17.7238H51.9328V0.276173H47.3707V2.6411ZM42.508 14.3346C39.8022 14.3346 37.6016 12.0064 37.6016 9.14333C37.6016 6.46553 39.4369 3.69509 42.508 3.69509C45.1666 3.69509 47.4127 6.19111 47.4127 9.14333C47.4127 12.0064 45.212 14.3346 42.508 14.3346Z" fill="#242731" />
            <path d="M9.31462 7.36396C6.92523 6.89552 4.44494 6.60886 4.44494 5.15459C4.44494 4.03068 5.97261 3.42241 7.85512 3.42241C10.3634 3.42241 11.3527 4.44319 11.3527 5.24723H16.0511C16.0511 1.37211 11.9645 0 7.88308 0C3.42241 0 0 2.18489 0 5.24723C0 9.31987 4.14081 10.0383 7.57021 10.6133C10.0225 11.0241 12.2301 11.3457 12.2301 12.6741C12.2301 13.7805 11.0416 14.5444 8.25364 14.5444C4.71237 14.5444 4.44669 12.7825 4.44669 12.7825H0.00699048C0.00699048 14.9237 2.27054 17.9983 8.25364 17.9983C13.4956 17.9983 16.6908 15.913 16.6908 12.4679C16.6891 8.72907 12.5168 7.99321 9.31462 7.36396Z" fill="#242731" />
        </svg>
        <Box display={"flex"} gap={"4.75px"} lineHeight={1}>
            {userToken && <Button
                sx={{
                    padding: "3px 8px",
                    minWidth: "100px",
                    width: "40px",
                    fontSize: "12px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #0000004A",
                }}
                onClick={handleSignOut}
            >
                <Box display={"flex"} gap={"4.75px"}>
                    <FontAwesomeIcon icon={faArrowRightFromBracket} flip="horizontal" />
                    <Typography fontSize={"12px"} fontWeight={500} lineHeight={1}>
                        {translate("signOut")}
                    </Typography>
                </Box>
            </Button>}
            <Select
                sx={{
                    "& .MuiSelect-select": {
                        padding: "0px !important",
                    },
                    "& .MuiSelect-icon": {
                        top: "27%",
                        right: "8px",
                        height: "12px",
                        width: "12px",
                        fill: "#000"
                    },
                    padding: "3px 8px",
                    minWidth: "100px",
                    width: "40px",
                    fontSize: "12px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                }}
                defaultValue={localStorage.getItem("lang") ?? selectedLanguage}
                onChange={(event: any) => {
                    handleChangeLanguage(event.target.value)
                }}
                renderValue={(selected: any) => {
                    const getSelected = regionalLanguages?.filter((options: any) => {
                        return options?.id == selected ? options.label : ""
                    })

                    if (getSelected?.length > 0) {
                        return getSelected.map((options: any) => (
                            <>
                                <FontAwesomeIcon key={options.id} icon={faGlobe} style={{ color: "#000", height: "12px", width: "12px" }} />
                                <span
                                    key={options.label}
                                    style={{ marginLeft: "8px", fontFamily: "Poppins", fontSize: "12px" }}
                                >
                                    {options.label}
                                </span>
                            </>
                        ))
                    }
                }}
                inputProps={{
                    "aria-label": "Without label",
                    sx: {
                        padding: "3px",
                    },
                }}
            >
                {regionalLanguages?.map((option: any) => (
                    <MenuItem
                        sx={{
                            fontSize: "12px",
                            borderRadius: 0,
                            padding: 0,
                            paddingTop: "3px",
                            paddingBottom: "3px",
                            justifyContent: "center",
                        }}
                        key={option?.id}
                        value={option?.id}
                    >
                        {option?.label}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    </Box>
}

export default MainHeaderComponent